/**
 * What the ticket's limit price becomes when the user switches outcome.
 *
 * A price in the ticket is in the terms of the outcome it is on, so the same
 * order seen from the other outcome is `100 − P`: 60¢ on UP is 40¢ on DOWN,
 * and switching back gives 60¢ again. Buy and Sell need nothing — a price is
 * the same number on both tabs, so the ticket keeps it as it is.
 *
 * Only a whole price 1–99 is moved. Anything else — empty, half typed, out of
 * range — is left exactly as the user typed it, because there is no
 * complement to give and rewriting their text would lose it.
 *
 * No React (invariant 10).
 */

import { complementPriceCents } from './sell-shape'

export function priceTextForOtherOutcome(text: string): string {
  const trimmed = text.trim()
  if (!/^\d{1,2}$/.test(trimmed)) return text
  const cents = Number(trimmed)
  if (cents < 1 || cents > 99) return text
  return String(complementPriceCents(cents))
}
